import * as React from 'react'
import { SERVICE_COLUMN } from '../../../state/constants/index'
import ListColumnsMenu from '../../ui/ListColumnsMenu'

interface IServiceListColumnsMenuProps {
  columns: string[]
  onUpdateColumns: (columns: string[]) => void
}

const ServiceListColumnsMenu = ({ columns = [], onUpdateColumns }: IServiceListColumnsMenuProps) => {
  const createColumnClickHandler = (column: string) => () => {
    let updatedColumns
    if (columns.indexOf(column) !== -1) {
      updatedColumns = columns.filter(it => it !== column)
    } else {
      updatedColumns = [...columns, column]
    }
    onUpdateColumns(updatedColumns)
  }

  return (
    <ListColumnsMenu>
      <div className='flex flex-column items-start pl2 pr2 pb2' style={{ width: '200px' }}>
        <p className='h5 font-grey2'>SHOW COLUMNS</p>
        {[
          SERVICE_COLUMN.ICON,
          SERVICE_COLUMN.NAME,
          SERVICE_COLUMN.INTERNALNAME,
          SERVICE_COLUMN.MEMBERSHIP_REQUIRED,
          SERVICE_COLUMN.VIEW_OPTIONS,
          SERVICE_COLUMN.TRIP_LIMIT,
          SERVICE_COLUMN.PROGRAM
        ].map(it => {
          const checked = columns.indexOf(it) !== -1
          return (
            <MenuItem key={`column-${it}`} name={it} checked={checked} handleClick={createColumnClickHandler(it)} />
          )
        })}
      </div>
    </ListColumnsMenu>
  )
}

const MenuItem = ({ name, checked, handleClick }: { name: string; checked: boolean; handleClick: () => void }) => (
  <div onClick={handleClick} className=''>
    <input type='checkbox' checked={checked} id={`checkbox-${name}`} />
    <span className='ml1 font-dark-grey'>{name}</span>
  </div>
)

export default ServiceListColumnsMenu



// WEBPACK FOOTER //
// ./src/components/services/list/ServiceListColumnsMenu.tsx